// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import moment from 'moment'
import VueSwal from 'vue-swal'
import Toasted from 'vue-toasted'
import App from './App'
import router from './router/index'
import store from './store/index'

// Template
import 'jquery/dist/jquery.min.js'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.min.js'

// Font Awesome Icons
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import icons from './icons'

// Vuetify
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

// Select with Search
import vSelect from 'vue-select'

// Base Layouts
import DashboardLayout from '@/components/layouts/DashboardLayout'
import EmptyLayout from '@/components/layouts/EmptyLayout'

// Global Filters
import './filters'

// Vue i18n
import VueI18n from 'vue-i18n'
import validationMessages from 'vee-validate/dist/locale/es'

// Validator
import VeeValidate from 'vee-validate'

// Configure Vue-i18n + Vee-Validate
Vue.prototype.moment = moment

Vue.use(VueI18n)
const i18n = new VueI18n({
  locale: 'es',
  silentTranslationWarn: true
})

const isAccountValid = (value) => {
  let height = '37137137137137137'
  let digitsHeight = height.toString().split('')
  let digits = value.toString().split('')
  let realDigits = digits.map(Number)
  let heightDigits = digitsHeight.map(Number)
  let result = 0
  for (let i = 0, len = realDigits.length; i < len - 1; i += 1) {
    result += (Number(realDigits[i]) * Number(heightDigits[i])) % 10
  }
  let digit = 10 - (result % 10)
  let lastDigit = realDigits[realDigits.length - 1]
  return lastDigit == digit && digits.length == 18
}

const isAccountNumber = (account) => {
  // Build an array with the digits in the card number
  let digits = account.split('')
  return digits.length == 10 || digits.length == 11
}

VeeValidate.Validator.extend('isClabe', isAccountValid, {
  validate: value => !!value
})

VeeValidate.Validator.extend('isBankAccount', isAccountNumber, {
  validate: value => !!value
})

Vue.use(VeeValidate, {
  i18nRootKey: 'validations',
  i18n,
  dictionary: {
    es: validationMessages
  }
})

// Register Components
icons.forEach(icon => library.add(icon))
Vue.component('fai', FontAwesomeIcon)

Vue.use(Vuetify)

Vue.component('v-select', vSelect)

Vue.component('dashboard-layout', DashboardLayout)
Vue.component('empty-layout', EmptyLayout)

Vue.config.productionTip = false

Vue.use(VueSwal)

Vue.use(Toasted)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js